export const MODALIDADE_SELECTED = "MODALIDADE_SELECTED";
export const EXTRACOES_SELECTED = "EXTRACOES_SELECTED";
//export const VALOR_CHANGED = 'VALOR_CHANGED'

export function selectModalidade(modalidade) {
  return {
    type: MODALIDADE_SELECTED,
    payload: modalidade,
  };
}

export function setExtracoesSelecionadas(extracoes) {
  return {
    type: EXTRACOES_SELECTED,
    payload: extracoes,
  };
}

// export const changeValorAposta = rawValue => ({
//     type: VALOR_CHANGED,
//     payload: rawValue
// })



// WEBPACK FOOTER //
// ./src/reducers/loteria/loteriaActions.js